var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',[_c('p',[_vm._v("Copyright © 2017 龙源数字传媒集团 京ICP备10216796号-6")]),_c('p',[_vm._v("Dragonsource.com Inc.All Rights Reserved")]),_c('p',[_vm._v("IP:"+_vm._s(_vm.userIp))])])])}
var staticRenderFns = []

export { render, staticRenderFns }